import { TFunction } from 'i18next'

export const TagStatuses = {
  success: 'success',
  info: 'processing',
  warning: 'warning',
  error: 'error',
  danger: 'error'
} as const

export const TagBillingStatuses = {
  paid: 'success',
  canceled: 'default',
  draft: 'warning',
  unpaid: 'error'
}

export const TagPriorityByValue = (
  t: TFunction
): Record<
  number,
  { title: string; color: (typeof TagStatuses)[keyof typeof TagStatuses] }
> => ({
  1: { title: t('task.high'), color: TagStatuses['danger'] },
  2: { title: t('task.medium'), color: TagStatuses['info'] },
  3: { title: t('task.low'), color: TagStatuses['success'] }
})

export const TagStatusByValue = (
  t: TFunction
): Record<
  number,
  { title: string; color: (typeof TagStatuses)[keyof typeof TagStatuses] }
> => ({
  0: { title: t('filter.uncompleted'), color: TagStatuses['warning'] },
  1: { title: t('filter.completed'), color: TagStatuses['success'] }
})
